// @flow

export const ErrorCode = {
  UNAUTHORIZED: 401
};
